import React from "react";
import "./verifyPersonalInfo.css";

const VerifyPersonalInfo = () => {
  return <div>VerifyPersonalInfo</div>;
};

export default VerifyPersonalInfo;
